export const applyModules = {
  hi: [
    {
      title: 'मॉड्यूल 1 — पंचायती राज व शासन',
      objective: 'उम्मीदवारों को पंचायती राज संस्थाओं, प्रक्रियाओं और कानूनी ढांचे की मज़बूत बुनियाद देना, ताकि वे प्रभावी ढंग से अपनी पंचायत का नेतृत्व कर सकें।',
      topics: [
        'संवैधानिक पृष्ठभूमि — 73वां संविधान संशोधन, पंचायतों की संवैधानिक स्थिति, स्थानीय स्वशासन के सिद्धांत',
        'त्रि-स्तरीय पंचायती राज व्यवस्था — ग्राम पंचायत (गांव स्तर), पंचायत समिति (ब्लॉक स्तर), ज़िला परिषद (ज़िला स्तर)',
        'ग्राम सभा — गठन व गणपूर्ति, शक्तियां व कार्य, बैठकें, भागीदारी व निर्णय-प्रक्रिया',
        'ग्राम पंचायत — गठन, चुनाव व कार्यकाल, वार्ड प्रतिनिधित्व, कार्य व शक्तियां',
        'पंचायत समिति (ब्लॉक स्तर) — गठन व चुनाव, कार्य व शक्तियां, विकास योजना में भूमिका',
        'ज़िला परिषद (ज़िला स्तर) — गठन व चुनाव, कार्य व शक्तियां, ज़िला विकास में भूमिका',
        'चुनाव व प्रतिनिधित्व — चुनाव प्रक्रिया, SC/ST/OBC आरक्षण, महिला आरक्षण (33% या राज्य कानून अनुसार), कार्यकाल, अयोग्यता व निष्कासन',
        'स्थायी समितियां — गठन, प्रमुख समितियां व भूमिका, समिति-आधारित शासन का महत्व',
        'शक्तियां, कार्य व वित्त — 11वीं अनुसूची (29 विषय), शक्तियों का हस्तांतरण, स्वयं का राजस्व स्रोत, वित्त आयोग व अनुदान',
      ],
    },
    {
      title: 'मॉड्यूल 2 — प्रशासन व सरकार',
      objective: 'उम्मीदवारों को प्रशासनिक ढांचे, प्रमुख हितधारकों व समन्वय की स्पष्ट समझ देना, ताकि प्रभावी व जवाबदेह शासन सुनिश्चित हो सके।',
      topics: [
        'मुखिया / ग्राम प्रधान — ग्राम पंचायत का प्रमुख, ग्राम सभा की अध्यक्षता, निर्णय व क्रियान्वयन, विकास कार्यों की निगरानी, पारदर्शिता सुनिश्चित करना',
        'वार्ड सदस्य — वार्ड व नागरिकों का प्रतिनिधित्व, स्थानीय मुद्दे उठाना, विकास कार्यों का समर्थन, नागरिकों व पंचायत के बीच कड़ी',
        'पंचायत सचिव — रिकॉर्ड व रजिस्टर बनाए रखना, दस्तावेज़ीकरण, पत्राचार व रिपोर्टिंग, योजना क्रियान्वयन में सहयोग',
        'खंड विकास अधिकारी (BDO) — ब्लॉक की पंचायतों की निगरानी, योजनाओं की स्वीकृति, तकनीकी व प्रशासनिक सहयोग',
        'ज़िला प्रशासन — नीति दिशा व निगरानी, बड़ी परियोजनाओं व बजट की स्वीकृति, अंतर-विभागीय समन्वय',
        'अन्य हितधारक — विधायक/सांसद, लाइन विभाग, सामुदायिक संगठन (CBO), NGO व स्वयं सहायता समूह, नागरिक',
      ],
    },
    {
      title: 'मॉड्यूल 3 — ग्रामीण विकास',
      objective: 'उम्मीदवारों को स्थानीय ज़रूरतों की पहचान, सरकारी योजनाओं तक पहुंच, और गांव के समग्र विकास हेतु संसाधनों के प्रभावी उपयोग में सक्षम बनाना।',
      topics: [
        'सरकारी योजनाएं — केंद्र व राज्य की प्रमुख योजनाएं, पात्रता, प्रक्रिया व अभिसरण',
        'ग्राम विकास योजना — आवश्यकता आकलन, प्राथमिकता निर्धारण, सूक्ष्म योजना व वार्षिक कार्य योजना',
        'वित्तीय प्रबंधन — पंचायत बजट, आय के स्रोत, अनुदान व फंड, वित्तीय पारदर्शिता',
        'जल, स्वच्छता व साफ-सफाई — पेयजल व जल संरक्षण, अपशिष्ट प्रबंधन, स्वच्छ गांव मिशन',
        'कृषि व संबद्ध क्षेत्र — टिकाऊ कृषि, सिंचाई, पशुपालन, मत्स्य व डेयरी, किसान सहयोग',
        'रोज़गार व आजीविका — मनरेगा, कौशल विकास, स्वयं सहायता समूह, ग्रामीण उद्यम',
        'स्वास्थ्य व पोषण — प्राथमिक स्वास्थ्य सेवाएं, मातृ व शिशु स्वास्थ्य, पोषण कार्यक्रम',
        'शिक्षा व मानव विकास — स्कूली शिक्षा, वयस्क व डिजिटल साक्षरता, युवा विकास',
        'बुनियादी ढांचा विकास — सड़क, नाली, स्ट्रीट लाइट, सामुदायिक भवन, सुगम्यता',
        'महिला सशक्तिकरण व सामाजिक न्याय — शासन में महिला भागीदारी, सामाजिक समावेशन',
        'सामुदायिक भागीदारी व संस्था निर्माण — ग्राम सभा में सहभागिता, स्वैच्छिक संगठन',
        'पर्यावरण व स्थिरता — वनरोपण, जलवायु अनुकूलन, प्राकृतिक संसाधन संरक्षण',
      ],
    },
    {
      title: 'मॉड्यूल 4 — नेतृत्व व नैतिकता',
      objective: 'निष्पक्ष, समावेशी और सामुदायिक हित में सेवा करने के लिए आवश्यक मूल्य, ईमानदारी व नेतृत्व मानसिकता विकसित करना।',
      topics: [
        'सत्यनिष्ठा व ईमानदारी — सच्चाई, पारदर्शिता, भ्रष्टाचार के प्रति शून्य सहनशीलता',
        'जवाबदेही व ज़िम्मेदारी — निर्णयों की ज़िम्मेदारी लेना, गलतियां स्वीकार कर सुधारना',
        'निष्पक्षता व गैर-भेदभाव — जाति/धर्म/लिंग/राजनीति के आधार पर पक्षपात न करना',
        'पारदर्शिता व खुलापन — सक्रिय जानकारी साझा करना, स्पष्ट संवाद',
        'सहानुभूति व जन-प्राथमिकता — समुदाय की ज़रूरतों को समझना, धैर्य व सम्मान से सेवा',
        'नैतिक निर्णय-क्षमता — दीर्घकालिक व सामुदायिक हित को प्राथमिकता',
        'उदाहरण से नेतृत्व — मूल्यों के साथ नेतृत्व, निरंतरता से विश्वास निर्माण',
        'समावेशन व सामाजिक सौहार्द — विविधता का सम्मान, शांतिपूर्ण विवाद-समाधान',
      ],
    },
    {
      title: 'मॉड्यूल 5 — निर्णय-क्षमता व समस्या समाधान',
      objective: 'स्थितियों का विश्लेषण करने, सही निर्णय लेने और पंचायत के लिए व्यावहारिक परिणाम देने की मानसिकता व दृष्टिकोण से लैस करना।',
      topics: [
        'परिस्थितिजन्य जागरूकता — ज़मीनी हकीकत को समझना, हितधारकों व सीमाओं की पहचान',
        'समस्या की पहचान — वास्तविक मुद्दे बनाम लक्षण, मूल कारण विश्लेषण',
        'प्राथमिकता व समझौता — आवश्यकता व प्रभाव के आधार पर प्राथमिकता तय करना',
        'साक्ष्य-आधारित निर्णय — डेटा, तथ्य व पिछले अनुभव का उपयोग',
        'सर्वसम्मति व हितधारक जुड़ाव — सही लोगों को शामिल करना, सहमति का निर्माण',
        'समाधान डिज़ाइन व नवाचार — व्यावहारिक व किफ़ायती समाधान',
        'क्रियान्वयन व निगरानी — योजना, संसाधन आवंटन, प्रगति की निगरानी',
      ],
    },
    {
      title: 'मॉड्यूल 6 — संचार व नेतृत्व दृष्टि',
      objective: 'स्पष्ट संवाद, प्रभावी नागरिक-जुड़ाव व समावेशी, समृद्ध और आत्मनिर्भर गांवों की दृष्टि के साथ नेतृत्व करने की क्षमता विकसित करना।',
      topics: [
        'सार्वजनिक भाषण व अभिव्यक्ति — स्पष्टता, आत्मविश्वास, सरल भाषा',
        'ग्राम सभा में सहभागिता — पारदर्शी प्रस्तुति, सक्रिय रूप से सुनना',
        'नागरिक जुड़ाव व पहुंच — विश्वास व तालमेल बनाना',
        'वार्ता व प्रभाव क्षमता — संवाद से मतभेद सुलझाना, सहयोग बनाना',
        'नेतृत्व दृष्टि — दीर्घकालिक लक्ष्य, सामूहिक कार्रवाई को प्रेरित करना',
        'योजना व रणनीतिक सोच — स्पष्ट प्राथमिकताएं व समय-सीमा',
        'नवाचार व निरंतर सुधार — नए विचारों व स्थानीय समाधानों को बढ़ावा',
        'युवा भागीदारी व क्षमता निर्माण — निर्णय-प्रक्रिया में युवाओं को शामिल करना',
      ],
    },
  ],
  en: [
    {
      title: 'Module 1 — Panchayati Raj & Governance',
      objective: 'Give candidates a strong foundation in Panchayati Raj institutions, processes, and legal framework so they can effectively lead their Panchayat.',
      topics: [
        'Constitutional background — 73rd Constitutional Amendment, constitutional status of Panchayats, principles of local self-governance',
        'Three-tier Panchayati Raj system — Gram Panchayat (village level), Panchayat Samiti (block level), Zila Parishad (district level)',
        'Gram Sabha — formation & quorum, powers & functions, meetings, participation & decision-making',
        'Gram Panchayat — formation, elections & tenure, ward representation, functions & powers',
        'Panchayat Samiti (block level) — formation & elections, functions & powers, role in development planning',
        'Zila Parishad (district level) — formation & elections, functions & powers, role in district development',
        'Elections & representation — election process, SC/ST/OBC reservation, women\'s reservation (33% or as per state law), tenure, disqualification & removal',
        'Standing committees — formation, key committees & roles, importance of committee-based governance',
        'Powers, functions & finance — 11th Schedule (29 subjects), devolution of powers, own revenue sources, Finance Commission & grants',
      ],
    },
    {
      title: 'Module 2 — Administration & Government',
      objective: 'Give candidates a clear understanding of administrative structure, key stakeholders, and coordination to ensure effective and accountable governance.',
      topics: [
        'Mukhiya / Gram Pradhan — head of Gram Panchayat, chairs Gram Sabha, decisions & implementation, monitors development work, ensures transparency',
        'Ward member — represents ward & citizens, raises local issues, supports development work, link between citizens & Panchayat',
        'Panchayat secretary — maintains records & registers, documentation, correspondence & reporting, supports plan implementation',
        'Block Development Officer (BDO) — monitors block Panchayats, approves schemes, technical & administrative support',
        'District administration — policy direction & oversight, approval of major projects & budgets, inter-departmental coordination',
        'Other stakeholders — MLA/MP, line departments, community organizations (CBO), NGOs & self-help groups, citizens',
      ],
    },
    {
      title: 'Module 3 — Rural Development',
      objective: 'Enable candidates to identify local needs, access government schemes, and use resources effectively for holistic village development.',
      topics: [
        'Government schemes — major central & state schemes, eligibility, process & convergence',
        'Village development plan — needs assessment, priority setting, micro-planning & annual action plan',
        'Financial management — Panchayat budget, revenue sources, grants & funds, financial transparency',
        'Water, sanitation & cleanliness — drinking water & water conservation, waste management, Swachh Village Mission',
        'Agriculture & allied sectors — sustainable agriculture, irrigation, animal husbandry, fisheries & dairy, farmer support',
        'Employment & livelihood — MGNREGA, skill development, self-help groups, rural enterprise',
        'Health & nutrition — primary health services, maternal & child health, nutrition programs',
        'Education & human development — school education, adult & digital literacy, youth development',
        'Infrastructure development — roads, drains, street lights, community buildings, accessibility',
        'Women empowerment & social justice — women\'s participation in governance, social inclusion',
        'Community participation & institution building — Gram Sabha participation, voluntary organizations',
        'Environment & sustainability — afforestation, climate adaptation, natural resource conservation',
      ],
    },
    {
      title: 'Module 4 — Leadership & Ethics',
      objective: 'Develop the values, integrity, and leadership mindset needed to serve fairly, inclusively, and in community interest.',
      topics: [
        'Integrity & honesty — truthfulness, transparency, zero tolerance for corruption',
        'Accountability & responsibility — taking responsibility for decisions, admitting mistakes and improving',
        'Fairness & non-discrimination — no bias based on caste/religion/gender/politics',
        'Transparency & openness — actively sharing information, clear communication',
        'Empathy & people-first approach — understanding community needs, serving with patience & respect',
        'Ethical decision-making — prioritizing long-term & community interest',
        'Leadership by example — leading with values, building trust through consistency',
        'Inclusion & social harmony — respecting diversity, peaceful dispute resolution',
      ],
    },
    {
      title: 'Module 5 — Decision-making & Problem Solving',
      objective: 'Equip candidates with the mindset and approach to analyze situations, make right decisions, and deliver practical outcomes for the Panchayat.',
      topics: [
        'Situational awareness — understanding ground reality, identifying stakeholders & constraints',
        'Problem identification — real issues vs symptoms, root cause analysis',
        'Prioritization & trade-offs — setting priorities based on need & impact',
        'Evidence-based decisions — using data, facts & past experience',
        'Consensus & stakeholder engagement — involving the right people, building agreement',
        'Solution design & innovation — practical & cost-effective solutions',
        'Implementation & monitoring — planning, resource allocation, tracking progress',
      ],
    },
    {
      title: 'Module 6 — Communication & Leadership Vision',
      objective: 'Develop the ability to lead with clear communication, effective citizen engagement, and a vision for inclusive, prosperous, and self-reliant villages.',
      topics: [
        'Public speaking & expression — clarity, confidence, simple language',
        'Gram Sabha participation — transparent presentation, active listening',
        'Citizen engagement & outreach — building trust & rapport',
        'Dialogue & influence — resolving differences through conversation, building cooperation',
        'Leadership vision — long-term goals, inspiring collective action',
        'Planning & strategic thinking — clear priorities & timelines',
        'Innovation & continuous improvement — promoting new ideas & local solutions',
        'Youth participation & capacity building — involving youth in decision-making',
      ],
    },
  ],
};
